export default "__VITE_ASSET__BBiYPQoh__"